export default "__VITE_ASSET__Dh5sTmjg__"